import { IncomingMessageRequest } from "../messages/methods/message";
import { IncomingRequestDelegate } from "../messages/incoming-request";
import { IncomingRequestMessage } from "../messages/incoming-request-message";
import { NonInviteServerTransaction } from "../transactions/non-invite-server-transaction";
import { UserAgentCore } from "../user-agent-core/user-agent-core";
import { UserAgentServer } from "./user-agent-server";

/**
 * MESSAGE UAS.
 * @public
 */
export class MessageUserAgentServer extends UserAgentServer implements IncomingMessageRequest {
  constructor(core: UserAgentCore, message: IncomingRequestMessage, delegate?: IncomingRequestDelegate) {
    super(NonInviteServerTransaction, core, message, delegate);
  }
}
